<ng-container [ngSwitch]="rrsService.view$ | async">
  <app-reference-room-settings-assign-no-room
    *ngSwitchCase="ReferenceRoomSettingsView.NoRooms"
  ></app-reference-room-settings-assign-no-room>
  <app-reference-room-settings-manage-room
    [gatewaySerial]="installationDetailsStore.gatewaySerial$ | async"
    *ngSwitchCase="ReferenceRoomSettingsView.ManageRoom"
  ></app-reference-room-settings-manage-room>
  <app-reference-room-settings-assign-room
    *ngSwitchCase="ReferenceRoomSettingsView.AssignRoom"
  ></app-reference-room-settings-assign-room>
</ng-container>
